import { readonly, ref } from 'vue';
import { generatePin, resetPin } from '@/services/oto/sellers';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
export function usePinManagement(isNewSeller) {
    const { t } = i18n.global;
    const toast = useToast();
    const pin = ref('');
    const isLoadingPin = ref(false);
    async function generateNewPin(sellerId, storeId) {
        isLoadingPin.value = true;
        try {
            const pinAction = isNewSeller.value ? generatePin() : resetPin(sellerId, storeId);
            const { data, errors, success } = await pinAction;
            if (!success || errors.length) {
                throw new Error(i18n.global.t('errors.err-500'));
            }
            pin.value = data.pin;
            if (!isNewSeller.value) {
                toast.success(i18n.global.t('store-management.sellers.reset-pin-success'), {
                    timeout: 5000,
                });
            }
        }
        catch (error) {
            clearPinValue();
            toast.error(i18n.global.t('errors.err-500'), {
                timeout: 5000,
            });
        }
        finally {
            isLoadingPin.value = false;
        }
    }
    const copyText = async () => {
        await navigator.clipboard.writeText(pin.value);
        toast.success(t('store-management.sellers.pin-copied'), {
            timeout: 5000,
        });
    };
    function getCustomTextPinButton() {
        if (isLoadingPin.value)
            return t('store-management.sellers.loading');
        return isNewSeller.value ? t('store-management.sellers.generate-pin') : t('store-management.sellers.reset-pin');
    }
    function clearPinValue() {
        pin.value = '';
        isLoadingPin.value = false;
    }
    return {
        // States
        generatedPin: readonly(pin),
        // Functions
        generateNewPin,
        copyText,
        getCustomTextPinButton,
        clearPinValue,
    };
}
